import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { BUTTON_SECONDARY } from 'components/TCButton/styles';

interface IStyleProps {
  buttonTextColor?: string;
}

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const Title = styled.h2`
  text-align: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 64px 0px 2px 0px;
`;

export const Container = styled.div`
  width: calc(100% - 206px);
`;

export const ContainerCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonContainer = styled.div` 
    margin-bottom: 42px;
    ${BUTTON_SECONDARY}{
        width: 200px;  
        font-family: Rubik;
        font-size: 14px;
        font-weight: 500;
        margin-left: auto;
        margin-right: auto;
    }
`;

export const ButtonText = styled.span` 
    color: ${(props: IStyleProps) => (props.buttonTextColor ? props.buttonTextColor : '#fff')};
`;
